import { render, staticRenderFns } from "./PostulatedProjectGeneralTab.vue?vue&type=template&id=395a89a6&scoped=true"
import script from "./PostulatedProjectGeneralTab.vue?vue&type=script&lang=js"
export * from "./PostulatedProjectGeneralTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395a89a6",
  null
  
)

export default component.exports